import UsdcIcon from '@/assets/icons/usd-coin-usdc.svg';
import UsdtIcon from '@/assets/icons/tether-usdt.svg';

export const tokenLabelMap: Record<string, string> = {
  USDC: 'USDC - USD Coin',
  USDT: 'USDT - Tether',
  esUSD: 'esUSD',
  esEUR: 'esEUR',
};

export const tokenIconMap: Record<string, string> = {
  USDC: UsdcIcon,
  USDT: UsdtIcon,
};

export const tokens = [
  { value: 'USDC', label: 'USDC - USD Coin', icon: UsdcIcon },
  { value: 'USDT', label: 'USDT - Tether', icon: UsdtIcon },
  { value: 'esUSD', label: 'esUSD' },
  { value: 'esEUR', label: 'esEUR' },
];

export function getTokenLabel(token: string) {
  return tokenLabelMap[token] ?? token;
}

export function getTokenIcon(token: string) {
  return tokenIconMap[token];
}
